<template lang="pug">
  v-navigation-drawer(
    app
    permanent
    fixed
    :color="$vuetify.theme.currentTheme.drawer"
    clipped
    floating
    class="drawer"
    width="216"
  )
    template(v-slot:prepend)
      nuxt-link(
        to="/documents"
        class="d-flex align-center link"
        exact
        active-class="link--active"
      )
        v-list-item(class="list__item px-2")
          v-list-item-icon(class="mr-0")
            e-svg-icon(size="sm") arrow-narrow-left
          v-list-item-title(class="link__text") {{ $t('Come back to account') }}
    e-navigation-links(:items="navItems")
</template>

<script>
import { adminMenuItems } from '~/const/adminMenuItems'
import ENavigationLinks from '~/components/elements/links/e-navigation-links'

export default {
  name: 'AdminDrawer',
  components: { ENavigationLinks },
  data() {
    return {
      activeLink: null
    }
  },
  computed: {
    navItems() {
      return adminMenuItems
    }
  }
}
</script>

<style scoped lang="scss">
.drawer {
  padding: 0 8px;
}
</style>
